import React from 'react';

export default function PatientStatementButton(props) {
  const { orderId, onClick, children } = props;

  const handleClick = () => {
    if (onClick) {
      onClick(orderId);
    }
  };

  return (
    <span>
      <span
        className="pointer"
        onClick={handleClick}
      >
        {children}
      </span>
    </span>
  );
}